<template>
  <div>
    <label class="typo__label">{{ label }}</label>
    <multiselect
      v-model="value"
      placeholder
      selectLabel
      deselectLabel="ลบ"
      selectedLabel="เลือกแล้ว"
      :label="labelBy"
      :track-by="trackBy"
      :options="truckTypeOptions"
      :option-height="100"
      :multiple="true"
      :taggable="true"
      @select="selectValue"
      @remove="removeValue"
      :searchable="false"
    >
      <template slot="option" slot-scope="props">
        <b-row>
          <b-col sm="3" class="align-self-center">
            <b-img class="logisty-truck-icon" :src="'/img/truck_icon/' + props.option.icon" fluid></b-img>
          </b-col>
          <b-col sm="9" class="align-self-center">
            <span>{{ props.option.typeName }}</span>
          </b-col>
        </b-row>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  name: 'multi-select-truck-tag',
  props: {
    label: {
      default: null,
      required: true
    },
    value: {
      default: function () {
        return []
      },
      required: true
    },
    labelBy: {
      default: 'typeName'
    },
    trackBy: {
      default: 'typeName'
    }
  },
  data () {
    return {
      truckTypeOptions: []
    }
  },
  async mounted () {
    await this.$store.dispatch('loadTruckType')
    let truckTypeOptions = this.$store.state.truckType
    let tempList = []

    tempList = truckTypeOptions.filter(x => x.category === '4ล้อ')
    this.truckTypeOptions = this.truckTypeOptions.concat(tempList)

    tempList = truckTypeOptions.filter(x => x.category === '6ล้อ')
    this.truckTypeOptions = this.truckTypeOptions.concat(tempList)

    tempList = truckTypeOptions.filter(x => x.category === '10ล้อ')
    this.truckTypeOptions = this.truckTypeOptions.concat(tempList)

    tempList = truckTypeOptions.filter(x => x.category === 'รถพ่วง')
    this.truckTypeOptions = this.truckTypeOptions.concat(tempList)

    tempList = truckTypeOptions.filter(x => x.category === 'เทรลเลอร์')
    this.truckTypeOptions = this.truckTypeOptions.concat(tempList)
  },
  methods: {
    selectValue (value) {
      this.value.push(value)
    },
    removeValue (removeItem) {
      this.value.splice(this.value.indexOf(removeItem), 1)
    }
  }
}
</script>
